/** 未选中图层时的页面属性。 */
import { Input, InputNumber, Radio, Select, ColorPicker } from 'antd';
import { CANVAS_HEIGHT, type Page } from '@h5/schema';
import { useEditorStore } from '../store/store';
import { Field } from './Field';
import { AssetInput } from './setters/AssetInput';

export function PagePanel({ page }: { page: Page }) {
  const { setPageProps } = useEditorStore.getState();
  const bg = page.background;
  const setBg = (next: Page['background']) => setPageProps(page.id, { background: next });

  return (
    <div style={{ padding: 12 }}>
      <div style={{ fontWeight: 500, marginBottom: 12 }}>页面属性</div>
      <Field label="名称"><Input size="small" value={page.name} onChange={(e) => setPageProps(page.id, { name: e.target.value })} /></Field>
      <Field label="模式" inline>
        <Radio.Group size="small" optionType="button" buttonStyle="solid" value={page.mode}
          options={[{ label: '一屏', value: 'fixed' }, { label: '长页', value: 'long' }]}
          onChange={(e) => setPageProps(page.id, { mode: e.target.value })} />
      </Field>
      {page.mode === 'long' && (
        <Field label="高度（设计像素）" inline>
          <InputNumber size="small" min={CANVAS_HEIGHT} step={50} value={page.height} onChange={(v) => setPageProps(page.id, { height: Math.max(CANVAS_HEIGHT, v ?? CANVAS_HEIGHT) })} />
        </Field>
      )}
      <Field label="切换效果">
        <Select style={{ width: '100%' }} value={page.transition}
          options={[{ label: '上滑', value: 'slide-up' }, { label: '淡入淡出', value: 'fade' }, { label: '无', value: 'none' }]}
          onChange={(v) => setPageProps(page.id, { transition: v })} />
      </Field>
      <Field label="背景类型" inline>
        <Radio.Group size="small" optionType="button" buttonStyle="solid" value={bg.type}
          options={[{ label: '纯色', value: 'color' }, { label: '图片', value: 'image' }]}
          onChange={(e) => setBg(e.target.value === 'color' ? { type: 'color', color: bg.type === 'color' ? bg.color : (bg.color ?? '#ffffff') } : { type: 'image', src: '', color: bg.type === 'color' ? bg.color : bg.color, fit: 'cover' })} />
      </Field>
      <Field label="背景色" inline>
        <ColorPicker showText format="hex" value={(bg.type === 'color' ? bg.color : bg.color) ?? '#ffffff'}
          onChangeComplete={(c) => setBg(bg.type === 'color' ? { type: 'color', color: c.toHexString() } : { ...bg, color: c.toHexString() })} />
      </Field>
      {bg.type === 'image' && (
        <>
          <Field label="背景图"><AssetInput value={bg.src} accept="image/*" preview="image" onChange={(src) => setBg({ ...bg, src })} /></Field>
          <Field label="填充" inline>
            <Radio.Group size="small" optionType="button" value={bg.fit}
              options={[{ label: '覆盖', value: 'cover' }, { label: '包含', value: 'contain' }, { label: '拉伸', value: 'fill' }]}
              onChange={(e) => setBg({ ...bg, fit: e.target.value })} />
          </Field>
        </>
      )}
    </div>
  );
}
